/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_On_Vs_Desktop_TitleInputs */

const en_wc_on_vs_desktop_title = /** @type {(inputs: Wc_On_Vs_Desktop_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online or desktop?`)
};

/**
* | output |
* | --- |
* | "Online or desktop?" |
*
* @param {Wc_On_Vs_Desktop_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_on_vs_desktop_title = /** @type {((inputs?: Wc_On_Vs_Desktop_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_On_Vs_Desktop_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_on_vs_desktop_title(inputs)
});
export { wc_on_vs_desktop_title as "wc.on.vs_desktop_title" }